import { c as _c } from "react/compiler-runtime";
import * as React from "react";
function PremiumGem(props) {
  const $ = _c(13);
  let t0;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="#e1f5fe" d="m4.01 47.94l17.48-26.51L35.03 36.9z" />;
    t1 = <path fill="#81d4fa" d="M44.11 68.26L4.01 47.94L35.03 36.9z" />;
    t2 = <path fill="#64b5f6" d="M63.94 43.06L35.03 36.9l9.08 31.36z" />;
    t3 = <path fill="#0288d1" d="m123.87 47.94l-17.48-26.51L92.85 36.9z" />;
    t4 = <path fill="#81d4fa" d="m83.77 68.26l40.1-20.32L92.85 36.9z" />;
    t5 = <path fill="#e1f5fe" d="m63.94 43.06l28.91-6.16l-9.08 31.36z" />;
    t6 = <path fill="#b2ebf2" d="m83.77 68.26l-19.83-25.2l-19.83 25.2z" />;
    t7 = <path fill="#b3e5fc" d="M43 10.06h41.88l21.51 11.37L92.85 36.9l-28.91 6.16l-28.91-6.16l-13.54-15.47z" />;
    t8 = <path fill="#1e88e5" d="M63.94 117.27L4.01 47.94l40.1 20.32z" />;
    t9 = <path fill="#b3e5fc" d="m63.94 117.27l59.93-69.33l-40.1 20.32z" />;
    t10 = <path fill="#e1f5fe" d="m83.77 68.26l-19.83 49.01l-19.83-49.01z" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] !== props) {
    t11 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</svg>;
    $[11] = props;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}
export default React.memo(PremiumGem);